import React from 'react';
export function Hero() {
  return <div className="mb-8" data-id="element-78">
      <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 leading-tight mb-6 font-sans" data-id="element-79">
        My Daughter Stopped Looking at Me at Breakfast—
        <span className="bg-[#FEF3C7] px-1" data-id="element-80">
          Then I Discovered the Real Reason I Couldn't Stop Drinking
        </span>
      </h1>
    </div>;
}